import React from "react"
import { Container } from "./style"
import { Outlet, useLocation } from "react-router-dom"
import Footer from "components/Footer"

const Content = ({ ...rest }) => {
  const location = useLocation()
  return (
    <>
      <Container maxHeight={location.pathname == "/" ? true : false} {...rest}>
        <Outlet />
      </Container>
      {location.pathname == "/" && <Footer />}
    </>
  )
}

export default Content
